import type { ReactNode } from "react";

interface FieldProps {
  label: string;
  hint?: string;
  error?: string;
  children: ReactNode;
}

export function Field({ label, hint, error, children }: FieldProps) {
  return (
    <label className="block">
      <span className="block text-[15px] font-medium text-ink mb-2">{label}</span>
      {children}
      {hint && !error && <span className="text-xs text-muted mt-1.5 block">{hint}</span>}
      {error && <span className="text-xs text-[var(--icon-red)] mt-1.5 block">{error}</span>}
    </label>
  );
}
